import axios from "@src/libraries/axios";
import swal from "@src/libraries/sweetalert";
import { i18n } from "@src/plugins/i18n";
import { silentReport } from "@src/assets/js/report";
import storage from "@src/assets/js/requests/storage";
import { headerAttr, isType, timeout } from "@src/assets/js/utils";
import { throwSwal } from "@src/assets/js/exceptions";
import { fakePromise, stringify } from "@src/assets/js/utils";
const requests = {};
function _http(url, headers) {
    if (requests[url])
        return requests[url];
    const request = _requestPromise(url, headers);
    requests[url] = request;
    return request;
}
async function _requestPromise(url, headers) {
    headers = headers || {};
    headers = Object.assign({}, axios.defaults.headers, headers);
    const response = await axios({
        method: "get",
        url,
        headers
    });
    setTimeout(() => delete requests[url], 1);
    if (!response)
        return;
    if (response.status >= 400) {
        console.log(">= 400");
        return throwSwal(response.data);
    }
    return response.data;
}
export default {
    async get(key, type, headers) {
        headers = headers || {};
        headers["cache-control"] = headers["cache-control"] || "max-age=0, no-cache, no-store, private";
        const get = await _http(key, headers);
        if (!get)
            return get;
        if (!isType(get, type)) {
            const getType = Object.prototype.toString.call(get);
            silentReport("wrong type '" + getType + "' for '" + key + "' " + type, {
                key,
                headers,
                get
            });
            if ("string" == typeof get) {
                await timeout(3000);
                return this.get(key, type, headers);
            }
            swal(i18n.t("http_error_type_title") || "Error en la recepción de datos", key, "error");
            return;
        }
        const maxAge = headerAttr(headers, "cache-control", "max-age");
        const keep = !maxAge || Number(maxAge) > 0;
        if (keep) {
            storage.set(key, get, {
                original: true
            });
        }
        else {
            storage.remove(key);
        }
        return get;
    },
    stale(key, type, headers) {
        const get = this.get;
        return fakePromise(async function (resolve) {
            const stale = await storage.stale(key, type);
            if (stale)
                resolve(stale);
            const httpResponse = await get(key, type, headers);
            if (!httpResponse || stringify(httpResponse) == stringify(stale)) {
                return;
            }
            resolve(httpResponse);
        });
    },
};
